import styled from 'styled-components';

// Colors
import * as colors from '@drivesally/sally-ui/lib/libs/colors';

// Constants
import statusColor from './statusColor.const';

const Card = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  min-height: 90px;
  padding: 16px;
  border-radius: 8px;
  border: 1px solid ${({status}) => colors[statusColor[status]] || colors.mediumBlueGrey};
  background: ${colors.white};
`;

export default Card;
